import * as angular from 'angular';

import { ComponentDefinition, ConnectionPointDTO } from '../../../models';
import { IConnectionPointService, ITagDefinitionService, IInputValuesService, ICalculatedValuesService } from '../../../services';

class UpdateDatabaseStateController implements angular.IComponentController {

    isLoadingPage: boolean;
    isUpdatingDatabase: boolean;
    connectionPointDto: ConnectionPointDTO;

    static $inject = [
        '$q',
        'connectionPointService',
        'tagDefinitionService',
        'inputValuesService',
        'calculatedValuesService'
    ];

    constructor(private _$q: angular.IQService,
        private _connectionPointService: IConnectionPointService,
        private _tagDefinitionService: ITagDefinitionService,
        private _inputValuesService: IInputValuesService,
        private _calculatedValuesService: ICalculatedValuesService) {
    }

    $onInit() {
        this.isLoadingPage = true;
        this._connectionPointService
            .getDefault()
            .then((cpDto: ConnectionPointDTO) => {
                this.connectionPointDto = cpDto;
                this._$q.all([
                    this._tagDefinitionService.count(),
                    this._inputValuesService.count(),
                    this._calculatedValuesService.count()
                ])
                    .then((responses: number[]) => {
                        this.connectionPointDto.connectionPoint.tagDefinitionsCount = responses[0];
                        this.connectionPointDto.connectionPoint.inputValuesCount = responses[1];
                        this.connectionPointDto.connectionPoint.calculatedValuesCount = responses[2];
                    });
                this.isLoadingPage = false;
            });
    }
}

export const wtUpdateDatabaseState: ComponentDefinition = {
    componentId: 'wtUpdateDatabaseState',
    controller: UpdateDatabaseStateController,
    template: require('./updateDatabaseState.component.html'),
    controllerAs: 'vm',
    bindings: {

    }
};
